/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Response } from '../model/response';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MailService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Send mail
     * 
     * @param recipientAddresses 
     * @param subject 
     * @param body 
     * @param attachments 
     * @param isSendUblEnabled 
     * @param outgoingInvoiceId 
     * @param ublFileName 
     * @param attachmentNames 
     * @param defaultBCCMails 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendMail(recipientAddresses?: Array<string>, subject?: string, body?: string, attachments?: Array<Blob>, isSendUblEnabled?: boolean, outgoingInvoiceId?: number, ublFileName?: string, attachmentNames?: Array<string>, defaultBCCMails?: Array<string>, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<Response>;
    public sendMail(recipientAddresses?: Array<string>, subject?: string, body?: string, attachments?: Array<Blob>, isSendUblEnabled?: boolean, outgoingInvoiceId?: number, ublFileName?: string, attachmentNames?: Array<string>, defaultBCCMails?: Array<string>, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<Response>>;
    public sendMail(recipientAddresses?: Array<string>, subject?: string, body?: string, attachments?: Array<Blob>, isSendUblEnabled?: boolean, outgoingInvoiceId?: number, ublFileName?: string, attachmentNames?: Array<string>, defaultBCCMails?: Array<string>, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<Response>>;
    public sendMail(recipientAddresses?: Array<string>, subject?: string, body?: string, attachments?: Array<Blob>, isSendUblEnabled?: boolean, outgoingInvoiceId?: number, ublFileName?: string, attachmentNames?: Array<string>, defaultBCCMails?: Array<string>, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {










        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void | HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (recipientAddresses) {
            recipientAddresses.forEach((element) => {
                formParams = formParams.append('RecipientAddresses', <any>element) || formParams;
            })
        }
        if (subject !== undefined) {
            formParams = formParams.append('Subject', <any>subject) || formParams;
        }
        if (body !== undefined) {
            formParams = formParams.append('Body', <any>body) || formParams;
        }
        if (attachments) {
            attachments.forEach((element) => {
                formParams = formParams.append('attachments', <any>element) || formParams;
            })
        }
        if (isSendUblEnabled !== undefined) {
            formParams = formParams.append('IsSendUblEnabled', <any>isSendUblEnabled) || formParams;
        }
        if (outgoingInvoiceId !== undefined) {
            formParams = formParams.append('OutgoingInvoiceId', <any>outgoingInvoiceId) || formParams;
        }
        if (ublFileName !== undefined) {
            formParams = formParams.append('UblFileName', <any>ublFileName) || formParams;
        }
        if (attachmentNames) {
            attachmentNames.forEach((element) => {
                formParams = formParams.append('attachmentNames', <any>element) || formParams;
            })
        }
        if (defaultBCCMails) {
            defaultBCCMails.forEach((element) => {
                formParams = formParams.append('defaultBCCMails', <any>element) || formParams;
            })
        }

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.post<Response>(`${this.basePath}/api/utilities/mails`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

}
